import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Why_Choose_Us from "./why-choose-us/Why_Choose_Us";
import Our_Products from "./our-products/Our_Products";
import Testimonials from "./testimonials/Testimonials";
import Talk_To_Us from "./talk-to-us/Talk_To_Us";
import All_Solutions from "./all-solutions/All_Solutions";
import Ready_to_Explore from "./ready-to-explore/Ready_to_Explore";

function Home() {
  return (
    <>
      <Banner />
      <Why_Choose_Us />
      <Our_Products />
      <Testimonials />
      <Talk_To_Us />
      <All_Solutions />
      <Ready_to_Explore />
    </>
  );
}

export default Home;
